import { saveAs } from 'file-saver';

import type { Binding } from '@/api/domains/bindings.types';
import type { PriceList } from '@/api/domains/price-lists.types';
import { httpClient } from '@/shared/lib/axios';

import type { RecordStatusId } from '../types/common.types';
import type { PaginatedList, PaginationParams } from '../types/pagination.types';

export type BindingsParams = PaginationParams & {
  unbond?: boolean;
  skipped?: boolean;
  active_only?: boolean;
  query?: string;
  price_list_ids?: number;
  special_price_list_ids?: number;
  order_guids?: string;
  record_status_ids?: RecordStatusId[];
  catalog_ids?: number;
};

export type BindingUpdateFormData = {
  drug_id: number;
  skipped?: boolean;
  skipped_reasons?: Record<string, string>;
  notes?: string;
};

type BindingExportSkippedParams = {
  price_list_id: PriceList['id'];
};

type ReviewBindingsParams = {
  binding_ids: number[];
};

export const BindingsApi = {
  fetchBindings: async (params?: BindingsParams) => {
    const { data } = await httpClient.get<PaginatedList<'items', Binding>>('binding/binding', { params });

    return data;
  },

  updateBinding: async (bindingId: number, formData: BindingUpdateFormData) => {
    const { data } = await httpClient.put<Binding>(`binding/${bindingId}`, formData);

    return data;
  },

  deleteBinding: (bindingId: number) => httpClient.put<void>(`binding/${bindingId}`, { drug_id: 0 }),

  reviewBindings: (params: ReviewBindingsParams) => httpClient.post<void>(`binding/review`, params),

  exportSkipped: async (params: BindingExportSkippedParams) => {
    const response = await httpClient.post<Blob>(`binding/export-skipped`, params, {
      responseType: 'blob',
    });

    const { data, headers } = response;
    const contentDisposition: string | undefined = headers['content-disposition'];

    let filename = 'price-list-skipped-positions-report.xlsx';

    if (contentDisposition) {
      const match = contentDisposition.match(/filename\*=utf-8''(.*)$/);

      if (match) {
        try {
          filename = decodeURIComponent(match[1]);
        } catch {
          filename = match[1];
        }
      }
    }

    saveAs(data, filename);
  },
};
